// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2607":"e044f77b","5535":"1329f7e8"}[chunkId] + ".chunk.css";
};